export function MergeMaps(firstMap) {
    var maps = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        maps[_i - 1] = arguments[_i];
    }
    var mergedMap = firstMap;
    for (var i = 0, l = maps.length; i < l; i++) {
        var map = maps[i];
        var iterator = map[Symbol.iterator]();
        var result = void 0;
        while (!(result = iterator.next()).done) {
            mergedMap.set(result.value[0], result.value[1]);
        }
    }
    return mergedMap;
}
//# sourceMappingURL=merge.js.map